<template>
  <div class="login-inputs">

  </div>
</template>

<script>
import store from '@store'
import toast from '@utils/toast'
import geoLocationService from '@/services/geoLocation'
import router from '../router';
import { mapGetters } from "vuex"

export default {
  name: 'AfterAuth',
  // components: {

  // },
  data: function() {
    return {
      process: null,
      mounted: false,
      executed: false,
      loginStatus: "idle",
      loginError: false,
      loginData: null,
      profileFetchingStatus: "idle",
      profileFetchingError: null,
      profileData: null,
      signingUpStatus: "idle",
      signingUpError: null,
      signUpData: null,
    }
  },
  computed: {
    ...mapGetters({
      keys: 'keys'
    }),
    // shouldLoadProfile: function() {
    //   return (this.process === "sign-in" && this.loginIsDone);
    // },
    ready: function() {
      return this.$auth.loading === false && this.$auth.isAuthenticated && this.mounted;
    }
  },
  watch: {
    loginStatus: function(newValue, oldValue) {
      if (newValue === "success") {
        store.commit('setToken', this.loginData);
        store.commit('setDriver', this.loginData);
        this.fetchProfile();
      } else if (newValue === "error") {
        if (this.loginError.code === 101) { // Bad user/pass
          toast.custom(`Cannot be loged in: ${this.loginError.message}`, "error");
          setTimeout(() => this.logOut(), 2000);
        }
      }
    },
    signingUpStatus: function(newValue, oldValue) {
      if (newValue === "error") {
        if (this.signingUpError?.code === 110) { // User exists
          this.login();
        } else {
          toast.custom(`Registration error: ${this.signingUpError}`, "error");
          //this.logOut();
        }
      } else if (newValue === "success") {
        toast.successMessage("Registration successful!");
        store.commit('setToken', this.signUpData);
        store.commit('setDriver', this.process === "sign-up-driver" ? 1 : 0);
        this.fetchProfile();
      }
    },
    profileFetchingStatus: function(newValue, oldValue) {
      if (newValue === "success") {
        this.$checkProfileWithRedirect();
      } else if (newValue === "error") {
        toast.custom(`Profile loading error: ${this.profileFetchingError}`, "error");
      }
    },
    ready: function() {
      this.onReady();
    }
  },
  mounted() {
    this.mounted = true;
  },
  methods: {
    logOut() {
      this.$auth.logout({
        logoutParams: {
          returnTo: `${window.location.origin}/login`
        }
      });
    },
    async onReady() {
      if (this.executed) return;
      this.executed = true;
      this.process = this.$route.query.from;
      switch(this.process) {
        case "sign-in":
          this.login();
          break;
        case "sign-up-driver":
          this.signUp({ role: "driver" });
          break;
        case "sign-up-advertiser":
          this.signUp({ role: "advertiser" });
          break;
        default:
          this.signUp();
      }
    },
    async login() {
      this.loginStatus = "in-progress";
      this.loginError = null;
      this.loginData = null;
      const token = await this.$auth.getTokenSilently({ authorizationParams: {
        audience: "https://api.adwayusa.com/auth0"
      }});

      const body = {
          "user": this.$auth.user.sub,
          "API_KEY": store.getters.keys.api_key,
          "data": {
            auth0: {
              ...this.$auth.user,
              token,
            },
            auth0_sub: this.$auth.user.sub,
            local_time: this.$moment(new Date()).format()
          }
        };

      const currentLocationPosition = await geoLocationService.getCurrentLocation();
      if (currentLocationPosition) {
        body.data.lat = currentLocationPosition.coords.latitude
        body.data.lon = currentLocationPosition.coords.longitude
      }

      try {
        var response = await this.request('/user/login', 'POST', body);
        if (response.code === 0) {
          this.loginData = response.data[0];
          this.loginStatus = "success";
          return response.data[0];
        } else {
          this.loginError = response;
        }
      } catch(error) {
        this.loginError = error;
      }
      this.loginStatus = "error";
    },
    async signUp(options = {}) {
      this.signingUpStatus = "in-progress";
      this.signingUpError = null;
      this.signUpData = null;

      const token = await this.$auth.getTokenSilently({ authorizationParams: {
        audience: "https://api.adwayusa.com/auth0"
      }});

      const body = {
          "user": this.$auth.user.sub,
          "API_KEY": store.getters.keys.api_key,
          "data": {
            auth0: {
              ...this.$auth.user,
              token,
            },
            driver: options.role === "driver" ? 1 : 0
          }
        };

      try {
        var response = await this.request('/user/create', 'POST', body);

        if (response.code === 0) {
          this.signUpData = response;
          this.signingUpStatus = "success";
          return response;
        } else {
          this.signingUpError = response;
        }
      } catch(error) {
          console.error(error);
        this.signingUpError = error;
      }
      this.signingUpStatus = "error";
    },
    async fetchProfile() {
      this.profileFetchingStatus = "in-progress";
      this.profileFetchingError = null;
      this.profileData = null;


      try {
        var response = await this.request('/get/profile', 'POST', { user: this.$auth.user.sub });
        if (response.code === 0) {
          store.commit('setUser', response.data[0]);
          this.profileData = response.data[0];
          this.profileFetchingStatus = "success";
          return response.data[0];
        } else {
          this.profileFetchingError = response.message;
        }
      } catch(error) {
        this.profileFetchingError = error.message;
      }
      this.profileFetchingStatus = "error";
    }
  }
}
</script>
